import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";

export const UPDATE_QUERY = print(gql`
  mutation UpdateEventClassification($data: UpdateEventClassificationInput!) {
    updateEventClassification(data: $data) {
      id
    }
  }
`);

export interface UpdateGql {
  updateEventClassification: {
    id: number;
  };
}
